module.exports = __webpack_public_path__ + "img/icon-doc-white.7c154c9a.svg";